import { getController, postController } from '@/controllers/request';
import { EVENTBUS_EVENTS } from '@/utils/constants';
import { mixin } from '@/utils/mixins';
import { eventBus } from '@/bus';

export default {
  namespaced: true,
  state: {
    selectedItems: [],
    massAttachCandidates: [],
    requestSent: false,
    metadata: {},
    itemsAttached: false,
    itemsAttaching: false,
    totalItemsToAttach: 0,
    nameAdvanced: ''
  },
  mixins: [mixin],
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    },
    setSelectedVacancies(state, val) {
      state.selectedItems = val;

      state.metadata.data.data.title.title_buttons[1].intents[0].request
        ?.dynamic_request_params.vacancy_ids
        ? (state.metadata.data.data.title.title_buttons[1].intents[0].request.dynamic_request_params.vacancy_ids =
            val)
        : (state.metadata.data.data.title.title_buttons[1].intents[0].request.dynamic_request_params.subpanel_id =
            val);
    },
    setMassSelectedVacancy(state, val) {
      state.selectedItems = val;
      state.metadata.data.data.title.title_buttons[1].intents[0].request.dynamic_request_params.vacancy_id =
        val;
    }
  },
  actions: {
    async loadItemsToAttach({ commit }, { url }) {
      try {
        commit('setParam', {
          name: 'requestSent',
          val: true
        });
        const request = await getController({
          url
        });
        commit(
          'common/setTableData',
          {
            module: url.split('&')[0].split('=')[1],
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        commit('setParam', {
          name: 'totalItemsToAttach',
          val: request.data.data.pageData.offsets.total
        });

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });

        commit('setParam', { name: 'metadata', val: request.data });
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('setParam', {
          name: 'requestSent',
          val: false
        });
      }
    },
    async loadItemsToMassAttach({ state, commit }, { url }) {
      try {
        commit('setParam', {
          name: 'requestSent',
          val: true
        });

        const formData = new FormData();
        let paramsArray = url.split('?')[1].split('&');

        paramsArray.forEach(param => {
          let paramInfo = param.split('=');
          if (paramInfo[0] == 'selected_ids[]') {
            state.massAttachCandidates.push(paramInfo[1]);
          }
          formData.append(paramInfo[0], paramInfo[1]);
        });

        const params = {
          header: {
            'Content-Type': 'multipart/form-data'
          }
        };

        const request = await postController({ options: formData, params });
        commit(
          'common/setTableData',
          {
            module: url.split('&')[0].split('=')[1],
            columns: request.data.data.data.data.title,
            rows: request.data.data.data.data.rows
          },
          { root: true }
        );

        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: request?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('setParam', {
          name: 'totalItemsToAttach',
          val: request.data.data.pageData.offsets.total
        });

        commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
          root: true
        });

        commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
          root: true
        });

        commit('filters/setFiltersConfig', request.data.custom_search, {
          root: true
        });
        commit('setParam', { name: 'metadata', val: request.data });
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('setParam', {
          name: 'requestSent',
          val: false
        });
      }
    },
    async attach({ commit }, intent) {
      try {
        commit('setParam', { name: 'itemsAttaching', val: true });

        const response = await mixin.methods.sendFormRequestFromIntent(intent);

        if (response.data?.result) {
          eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_SUCCESS);
        }
        if (response.data?.successfully && response.data?.unsuccessfully) {
          if (
            response.data.successfully.candidates.length &&
            !response.data.unsuccessfully.candidates.length
          ) {
            eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_SUCCESS, {
              messages: response.data.successfully.messages,
              goBack: true
            });
          } else if (
            response.data.successfully.candidates.length &&
            response.data.unsuccessfully.candidates.length
          ) {
            eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_SUCCESS, {
              messages: response.data.successfully.messages
            });
            eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_ERROR, {
              messages: response.data.unsuccessfully.messages
            });
          } else if (
            !response.data.successfully.candidates.length &&
            response.data.unsuccessfully.candidates.length
          ) {
            eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_ERROR, {
              messages: response.data.unsuccessfully.messages
            });
          }
        } else {
          if (!response?.data?.error) {
            if (intent.request.request_params?.vacancy_ids) {
              response.data?.result && !response.data?.error
                ? eventBus.$emit(EVENTBUS_EVENTS.ATTACHMENT_SUCCESS)
                : eventBus.$emit(
                    EVENTBUS_EVENTS.ATTACHMENT_ERROR,
                    response.data?.error
                  );
            } else if (intent.request.dynamic_request_params?.subpanel_id) {
              eventBus.$emit(
                EVENTBUS_EVENTS.ATTACHMENT_SHOW_CONFIRM_POPUP,
                response.data
              );
            }
          } else {
            eventBus.$emit(
              EVENTBUS_EVENTS.ATTACHMENT_ERROR,
              response.data?.error
            );
          }
        }

        commit('setParam', { name: 'itemsAttached', val: true });
      } catch (error) {
        console.error('error', error);
      } finally {
        commit('setParam', { name: 'itemsAttaching', val: false });
      }
    },
    async loadMassAttachmentData({ commit }, intent) {
      const request = await mixin.methods.sendFormRequestFromIntent(intent);

      commit(
        'common/setTableData',
        {
          module: 'HRPAC_VACANCY',
          columns: request.data.data.data.data.title,
          rows: request.data.data.data.data.rows
        },
        { root: true }
      );

      commit(
        'common/setParam',
        {
          name: 'tableFields',
          val: request?.data?.sugarconfig
        },
        {
          root: true
        }
      );

      commit('setParam', {
        name: 'totalItemsToAttach',
        val: request.data.data.pageData.offsets.total
      });

      commit('selectionPopup/setMetadataFields', request.data.sugarconfig, {
        root: true
      });

      commit('selectionPopup/popupPageConfig', request.data.data.pageData, {
        root: true
      });

      commit('filters/setFiltersConfig', request.data.custom_search, {
        root: true
      });

      commit('setParam', { name: 'metadata', val: request.data });
    }
  }
};
